<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="payManners"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            type="primary"
            @click="$refs.editPayManner.open(0)">
          新建
        </el-button>
        <el-button
            type="danger"
            @click="deleteIds">
          批量删除
        </el-button>
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          导出
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="付款方式">
            <el-input v-model.trim="filter.payNodeName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="payNodeType" align="center" label="付款方式"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <el-button type="primary" @click="$refs.editPayManner.open(scope.row.pmid)">编辑</el-button>
          <el-button type="primary" @click="$refs.allocationPayManner.open(scope.row.pmid)">分配客户</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <pay-manner-allocation ref="allocationPayManner" @save-success="getList(1)"/>
    <pay-manner-edit ref="editPayManner" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import PayMannerEdit from "@/views/information/PayManner/PayMannerEdit";
  import PayMannerAllocation from "@/views/information/PayManner/PayMannerAllocation";

  export default {
    name: "PayMannerList",
    components: {PayMannerAllocation, PayMannerEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        exportLoading: false,
        filter: {
          payNodeName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pmid);
          }
          this.$http
            .delete("basic","/payManners/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","/payManners",row.pmid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      // exportExcel() {
      //   window.open(window.config.basicServerUrl + "payManners/export");
      // },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","payManners/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
